import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import { Link as Anchor, useLocation } from 'react-router-dom';
import logo from '../../images/logo.jpeg';
import baseURL from '../url';
import Profile from '../Profile/Profile';
import './Navbar.css';

// Componente reutilizable para redes sociales
function Socials({ contactos }) {
    return (
        <>
            {contactos.instagram && (
                <a href={contactos.instagram} target="_blank" rel="noopener noreferrer">
                    <i className='fa fa-instagram'></i>
                </a>
            )}
            {contactos.telefono && (
                <a href={`https://wa.me/${contactos.telefono}`} target="_blank" rel="noopener noreferrer">
                    <i className='fa fa-whatsapp'></i>
                </a>
            )}
            {/*{contactos.facebook && (
                <a href={contactos.facebook} target="_blank" rel="noopener noreferrer">
                    <i className='fa fa-facebook'></i>
                </a>
            )}*/}
        </>
    )
}

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isStockDropdownOpen, setIsStockDropdownOpen] = useState(false);
    const [contactos, setContactos] = useState([]);
    const location = useLocation();
    const dropdownRef = useRef(null);

    useEffect(() => {
        cargarBanners();
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`)
            .then(response => response.json())
            .then(data => setContactos(data.contacto.reverse()[0] || {}))
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsStockDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`)
            .then(response => response.json())
            .then(data => {
                setImages(data.banner.map(banner => banner.imagen));
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar banners:', error));
    };

    const handleLinkClick = () => setIsOpen(false);
    const isActive = (path) => location.pathname === path;
    const isStockActive = () => ['/stock', '/stock/motos', '/stock/autos'].includes(location.pathname);
    const handleStockClick = (e) => { e.preventDefault(); setIsStockDropdownOpen(!isStockDropdownOpen); };
    const handleDropdownItemClick = () => setIsStockDropdownOpen(false);
    const handleMotosClick = () => handleDropdownItemClick();

    return (
        <header>
            <nav>
                {/* LOGO */}
                <Anchor to={`/`} className='logo'>
                    <img src={logo} alt="logo" />
                </Anchor>

                {/* REDES SOCIALES DESKTOP */}
                <div className='socials-navbar-desktop'>
                </div>

                {/* MENÚ DESKTOP */}
                <div className='desktop-menu'>
                    <Anchor to="/" className={isActive('/') ? 'active' : ''}>Inicio</Anchor>

                    <div
                        className={`dropdown ${isStockActive() ? 'active' : ''} ${isStockDropdownOpen ? 'open' : ''}`}
                        ref={dropdownRef}
                    >
                        <Anchor to="/stock" className="dropdown-toggle" onClick={handleStockClick}>
                            Stock
                        </Anchor>
                        <div className="dropdown-menu">
                            <Anchor
                                to="/stock/autos"
                                className={`dropdown-item ${isActive('/stock/autos') ? 'active' : ''}`}
                                onClick={handleDropdownItemClick}
                            >
                                🚗 Autos
                            </Anchor>
                            <Anchor
                                to="/stock/motos"
                                className={`dropdown-item ${isActive('/stock/motos') ? 'active' : ''}`}
                                onClick={handleMotosClick}
                            >
                                🏍️ Motos
                            </Anchor>
                        </div>
                    </div>

                    <Anchor to="/cotiza" className={isActive('/cotiza') ? 'active' : ''}>Quiero vender mi auto</Anchor>
                    <Anchor to="/financiacion" className={isActive('/financiacion') ? 'active' : ''}>Financiación</Anchor>
                    <Anchor to="/nosotros" className={isActive('/nosotros') ? 'active' : ''}>Nosotros</Anchor>
                </div>

                {/* HAMBURGUESA */}
                <div className='deFLexNavs'>
                    <div className={`nav_toggle ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span><span></span><span></span>
                    </div>
                </div>

                {/* MODAL MÓVIL */}
                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'></div>
                        ) : (
                            <>
                                <div className='fondo'>
                                    <img src={images[0]} alt={`imagen`} />
                                </div>
                                <div className='enlaces'>
                                    <Anchor to="/" onClick={handleLinkClick}>INICIO</Anchor>
                                    <Anchor to="/stock/autos" onClick={handleLinkClick} className="mobile-sub-item">&nbsp;&nbsp; AUTOS</Anchor>
                                    <Anchor to="/stock/motos" onClick={handleMotosClick} className="mobile-sub-item">&nbsp;&nbsp; MOTOS</Anchor>
                                    <Anchor to="/cotiza" onClick={handleLinkClick}>QUIERO VENDER MI AUTO</Anchor>
                                    <Anchor to="/financiacion" onClick={handleLinkClick}>FINANCIACIÓN</Anchor>
                                    <Anchor to="/nosotros" onClick={handleLinkClick}>NOSOTROS</Anchor>
                                </div>

                                {/* REDES SOCIALES MÓVIL */}
                                <div className='socials-navbar-mobile'>
                                    <Socials contactos={contactos} />
                                </div>

                                <Profile />
                            </>
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}
